export default __webpack_public_path__ + "static/media/lite.cb402eb8.jpg";